import React, { useState } from 'react';

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (colName: string, condition: string) => void;
}

export const FilterModal: React.FC<FilterModalProps> = ({ isOpen, onClose, onApply }) => {
  const [colName, setColName] = useState('A');
  const [condition, setCondition] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (colName && condition) {
      onApply(colName.trim().toUpperCase(), condition.trim());
      setCondition('');
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-xs border border-gray-300 pointer-events-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Create Filter</h2>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Column to Filter</label>
            <input
              type="text"
              placeholder="e.g., A, B, C"
              required
              autoFocus
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none uppercase"
              value={colName}
              onChange={(e) => setColName(e.target.value.replace(/[^a-zA-Z]/g, ''))}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Condition</label>
            <input
              type="text"
              placeholder="e.g., >100, Apple"
              required
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none"
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">Rows not matching this condition will be hidden.</p>
          </div>
          
          <div className="flex justify-end space-x-3 mt-6 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded font-medium transition text-sm">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded hover:bg-blue-100 font-medium shadow-sm transition text-sm">
              Apply Filter
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};